module.exports = __webpack_public_path__ + "static/img/product10.ef5b26c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product10.png
// module id = f/4k
// module chunks = 1